import { useResolvedHostname } from './routes'

import { dangerousNormalizePublicSrc } from '@/helpers/public'

export function useDeployAssetsPrefixData() {
  const resolvedHost = useResolvedHostname()
  return resolvedHost.deployAssetPrefixData
}

export function useNormalizePublicSrc() {
  const deployAssetPrefixData = useDeployAssetsPrefixData()

  const _normalizePublicSrc = (src: string) => {
    return dangerousNormalizePublicSrc(
      src,
      deployAssetPrefixData
        ? `${deployAssetPrefixData.originPrefix}${deployAssetPrefixData.pathPrefix}/public`
        : `/public`,
    )
  }

  return _normalizePublicSrc
}
